import { brandingService } from "@/services";
import { useQuery } from "@tanstack/react-query";

/**
 * Branding for the hostname this dashboard is served from.
 *
 * Never throws into the UI: an unknown host is a 404 and simply means "no
 * partner branding", which must render as plain Curo rather than an error. A
 * misconfigured DNS entry should not make the sign-in page unusable.
 */
export function useBranding() {
	return useQuery({
		queryKey: ["branding", window.location.host],
		queryFn: ({ signal }) => brandingService.get(window.location.host, signal),
		retry: false,
		staleTime: 5 * 60_000,
	});
}
